import styled from 'styled-components'

export default styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #ffffff;
  border: none;
  background-color: rgba(0, 0, 0, 1);
  opacity: ${ props => props.disabled ? '0.3' : '1' };
  font-family: 'ABChanel PB Regular S', Arial, sans-serif;
  font-size: 12px;
  html[lang=tw] & {
    font-size: 14px;
  }
  .add-to-cart-loading {
    margin: 0 auto;
  }
`



// WEBPACK FOOTER //
// ./src/styles/AddToBagBtn.js